import React, { useState, useEffect } from 'react';
import './blinker.scss';

const Blinker = ({ children, value, direction }) => {
  const [blinkClass, setBlinkClass] = useState('');
  const [prevValue, setPrevValue] = useState(value);

  useEffect(() => {
    if (value !== prevValue) {
      // Determine direction if not explicitly provided
      let blinkDirection = direction;
      
      if (!direction && prevValue !== null && value !== null) {
        const numValue = parseFloat(value);
        const numPrevValue = parseFloat(prevValue);
        
        if (!isNaN(numValue) && !isNaN(numPrevValue)) {
          blinkDirection = numValue > numPrevValue ? 'up' : numValue < numPrevValue ? 'down' : null;
        }
      }
      
      if (blinkDirection === 'up') {
        setBlinkClass('blink-green');
      } else if (blinkDirection === 'down') {
        setBlinkClass('blink-red');
      }
      
      // Reset blink class after animation duration
      setTimeout(() => {
        setBlinkClass('');
      }, 500);
    }
    
    setPrevValue(value);
  }, [value, direction]);

  return <span className={blinkClass}>{children}</span>;
};

export default Blinker;
